import {
    apiRequest,
    penataranUpdate
} from "../../../../../services/adapters/kepegawaian/penataranService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", penataranUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository